/**
 *    NodeList Polyfills
 *      - forEach
 *      - on ( action, callback )
 *      - off ( action, callback )
 *      - classList
 *        - add ( className )
 *        - remove ( className )
 *        - toggle ( className )
 */

// NodeList.forEach ( callback )
if (!NodeList.prototype.forEach) {
  NodeList.prototype.forEach = function forEach (callback) {
    [].forEach.call(this, callback);
  };
}

// NodeList.filter
if (!NodeList.prototype.filter) {
  NodeList.prototype.filter = function filter (callback) {
    return [].filter.call(this, callback);
  };
}

// NodeList.on ( action, callback )
if (!NodeList.prototype.on) {
  NodeList.prototype.on = function on (action, callback) {
    this.forEach(element => element.addEventListener(action, callback) );
  };
}

// NodeList.off ( action, callback )
if (!NodeList.prototype.off) {
  NodeList.prototype.off = function off (action, callback) {
    this.forEach(element => element.removeEventListener(action, callback) );
  };
}

/* NodeList.delegate( event, target, callback)
 * Delegate an event on specific childs of each elements in NodeList
 */
if (!NodeList.prototype.delegate) {
  NodeList.prototype.delegate = function delegate (eventName, target, callback) {
    this.forEach(element => element.delegate (eventName, target, callback));
  };
}


// CubeClassList is kind of a bridge :
//  - it keep the NodeList reference
//  - it implements add, remove & toggle methods to extends NodeList
function CubeClassList (list) {
  this.List = list;
}

// NodeList.classList.add
CubeClassList.prototype.add = function add (className) {
  this.List.forEach(el => el.classList.add(className));
};

// NodeList.classList.remove
CubeClassList.prototype.remove = function remove (className) {
  this.List.forEach(el => el.classList.remove(className));
};

// NodeList.classList.toggle
CubeClassList.prototype.toggle = function toggle (className) {
  this.List.forEach(el => {
    if (el.classList.contains(className)) {
      el.classList.remove(className);
    }
    else {
      el.classList.add(className);
    }
  });
};


// Define 'classList' on nodeList
Object.defineProperty(NodeList.prototype, 'classList', {
  get: function get () {
    return new CubeClassList(this);
  },
  enumerable: true,
  configurable: true
});



// WEBPACK FOOTER //
// ./src/modules-es5/commons/polyfills/node-list.js